const isScrollable = (element: HTMLElement): boolean => {
    const style = getComputedStyle(element);
    return (
        style.overflowY === 'auto' ||
        style.overflowY === 'scroll' ||
        style.overflowX === 'auto' ||
        style.overflowX === 'scroll'
    );
};

const hasScrollbars = (element: HTMLElement): boolean => {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

export const findScrollableWrapper = (element: HTMLElement | null): HTMLElement | undefined => {
    if (!element || !element.parentElement) return;

    return isScrollable(element.parentElement) && hasScrollbars(element.parentElement)
        ? element.parentElement
        : findScrollableWrapper(element.parentElement);
};
